import React from 'react'

import { slotForColor } from '../activityReport'

/**
 * Hover layer shared by the bar, line and donut charts.
 *
 * Zero-value series are dropped so a stacked bar with eight series does not show
 * six empty rows, and what is left is sorted largest-first so the tooltip reads
 * in the same order as the eye scans the stack.
 */
const ChartTooltip = ({ active, payload, label, total: showTotal }) => {
    if (!active || !payload || !payload.length) return null

    const rows = payload
        .filter((item) => item && Number(item.value) > 0)
        .map((item) => ({
            name: item.name || item.payload?.name || 'Unknown',
            value: Number(item.value),
            color: item.color || item.payload?.color,
        }))
        .sort((a, b) => b.value - a.value)

    if (!rows.length) return null

    const total = rows.reduce((sum, row) => sum + row.value, 0)

    return (
        <div className="incident-reports-tooltip">
            <div className="incident-reports-tooltip-title">{label || rows[0].name}</div>
            <div className="incident-reports-tooltip-list">
                {rows.map((row) => (
                    <div key={row.name} className="incident-reports-tooltip-row">
                        <span className={`incident-reports-tooltip-swatch viz-swatch viz-swatch--${slotForColor(row.color)}`} />
                        <span className="incident-reports-tooltip-branch">{row.name}</span>
                        <span className="incident-reports-tooltip-count">{row.value.toLocaleString()}</span>
                    </div>
                ))}
            </div>
            {showTotal && rows.length > 1 && (
                <div className="incident-reports-tooltip-total">
                    <span>Total</span>
                    <span>{total.toLocaleString()}</span>
                </div>
            )}
        </div>
    )
}

export default ChartTooltip
